'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/secondAgo.js
// module id = 731
// module chunks = 0